import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import LightModeRoundedIcon from "@mui/icons-material/LightModeRounded";
import { IconButton, Tooltip } from "@mui/material";
import { useAppColorMode } from "../theme";

export default function ColorModeToggle({ sx }) {
  const { mode, toggleColorMode } = useAppColorMode();
  const isDark = mode === "dark";

  return (
    <Tooltip title={`Switch to ${isDark ? "light" : "dark"} mode`}>
      <IconButton
        aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
        onClick={toggleColorMode}
        sx={{
          width: 38,
          height: 38,
          color: "text.secondary",
          border: "1px solid",
          borderColor: "divider",
          borderRadius: "10px",
          bgcolor: "background.paper",
          "&:hover": { bgcolor: "action.hover" },
          ...sx,
        }}
      >
        {isDark ? (
          <LightModeRoundedIcon sx={{ fontSize: 19 }} />
        ) : (
          <DarkModeRoundedIcon sx={{ fontSize: 19 }} />
        )}
      </IconButton>
    </Tooltip>
  );
}
